import { Env, getEnv } from '@cinch/oxd-utils/env/src'

enum FEATURES {
  SAVE_SEARCH = 'saveSearch',
  PROMO = 'promo',
  SELL_HOLD = 'sellHold',
  CAMBRIDGE = 'cambridge',
  IDENTIFY_USERS = 'identifyUsers',
  SERVICE_PLANS = 'servicePlans',
}

const hasFeatureFlag = (flag: FEATURES): boolean => {
  const envFeatures = getEnv(Env.FeatureToggles) || ''
  const featureFlags = envFeatures.split(',')

  return featureFlags.includes(flag)
}

export { FEATURES, hasFeatureFlag }
